import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({ standalone: false,
    selector: 'irb-security-penaltybar',
    templateUrl: './security-penaltybar.component.html',
    styleUrls: ['./security-penaltybar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SecurityPenaltybarComponent {
    _penaltyBarData: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] };
    penaltyAmt: any;
    penaltyDays: any;
    penaltyAmtPercentage: any;
    penaltyDaysPercentage: any;
    securityType: string;
    isMultipleSecurity: boolean;

    constructor() {
    }

    @Input()
    set penaltyBarData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this._penaltyBarData = value;
        this.loadData();
    }

    private loadData() {
        if (this._penaltyBarData && !this._penaltyBarData.multipleSecurity && this._penaltyBarData.securityData) {
            let securityDtls = this._penaltyBarData.securityData[0];
            this.penaltyAmt = (isNaN(securityDtls.redemptionPenaltyDollarAmount)
                || securityDtls.redemptionPenaltyDollarAmount == undefined
                || securityDtls.redemptionPenaltyDollarAmount == null)
                ? 0 : securityDtls.redemptionPenaltyDollarAmount;

            this.penaltyDays = (isNaN(securityDtls.tdaRedemptionPenaltyDays)
                || securityDtls.tdaRedemptionPenaltyDays == undefined
                || securityDtls.tdaRedemptionPenaltyDays == null)
                ? 0 : securityDtls.tdaRedemptionPenaltyDays;

            this.penaltyAmtPercentage = (isNaN(securityDtls.redemptionPenaltyPercent)
                || securityDtls.redemptionPenaltyPercent == undefined
                || securityDtls.redemptionPenaltyPercent == null)
                ? 0 : securityDtls.redemptionPenaltyPercent;
            this.penaltyDaysPercentage = (isNaN(securityDtls.redemptionPenaltyDays)
                || securityDtls.redemptionPenaltyDays == undefined
                || securityDtls.redemptionPenaltyDays == null)
                ? 0 : securityDtls.redemptionPenaltyDays;
        } else if (this._penaltyBarData && this._penaltyBarData.multipleSecurity) {
            this.isMultipleSecurity = true;
        }

    }
    isValid() {
        return true;
    }

}
